import userApis from '@apis/user';
import type { PermissionsDict } from '@assets/types/user';

interface State {
    pteLoginInfo: any;
    permissionsDict: Array<string>;
    permissionList: Array<PermissionsDict>;
}

const state: State = {
    permissionsDict: [], //权限字典表
    permissionList: [], //权限列表
    pteLoginInfo: {}
};

export default {
    namespaced: true,
    state,
    actions: {
        getVerifyCode() {
            return userApis.getVerifyCode();
        },
        sendForgetEmail({}: any, params: any) {
            return userApis.sendForgetEmail(params);
        }
    }
};
